import React from 'react'

const QuestionName = ({questionName, description, type}) => {
  return (
    <div className='txt-left mb-5 custom-question'>
        <h2 className='text-white txt-left'>{type !== 'video_content' && questionName}</h2>
        {description && <p className='text-secondary txt-left'>{description}</p>
}    </div>
  )
}

export default QuestionName